import { svg } from '@rxdi/lit-html';

export const MessageNotification = svg`

<svg
 enable-background="new 0 0 24 24"
 height="45"
 viewBox="0 0 24 24"
 width="45"
 xmlns="http://www.w3.org/2000/svg"
>
 <path
  d="m21 2.75c0-1.519-1.231-2.75-2.75-2.75h-12.5c-1.519 0-2.75 1.231-2.75 2.75v17c0 .199.079.39.22.53.141.141.332.22.53.22h16.5c.414 0 .75-.336.75-.75z"
  fill="#eceff1"
 />
 <g fill="#2196f3">
  <path
   d="m16.25 11.5h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  />
  <path
   d="m16.25 8.5h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  />
  <path
   d="m22.25 14h-2.756c-.778 0-1.452.501-1.676 1.247l-.859 2.862c-.16.533-.641.891-1.197.891h-7.524c-.556 0-1.037-.358-1.197-.891l-.859-2.861c-.224-.747-.897-1.248-1.676-1.248h-2.756c-.965 0-1.75.785-1.75 1.75v5.5c0 1.517 1.233 2.75 2.75 2.75h18.5c1.517 0 2.75-1.233 2.75-2.75v-5.5c0-.965-.785-1.75-1.75-1.75z"
  />
 </g>
 <path
  d="m12 0h-6.25c-1.519 0-2.75 1.231-2.75 2.75v11.25h1.506c.779 0 1.452.501 1.676 1.248l.859 2.861c.16.533.641.891 1.197.891h3.762v-7.5h-4.25c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.25v-1.5h-4.25c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.25z"
  fill="#cdd0d2"
 />
 <g fill="#1d83d4">
  <path d="m12 10h-4.25c-.414 0-.75.336-.75.75s.336.75.75.75h4.25z" />
  <path d="m12 7h-4.25c-.414 0-.75.336-.75.75s.336.75.75.75h4.25z" />
  <path
   d="m4.506 14h-1.506-1.25c-.965 0-1.75.785-1.75 1.75v5.5c0 1.517 1.233 2.75 2.75 2.75h9.25v-5h-3.762c-.556 0-1.037-.358-1.197-.891l-.859-2.861c-.224-.747-.897-1.248-1.676-1.248z"
  />
 </g>
 <path
  d="m12.25 5.5h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  fill="#2196f3"
 />
 <path d="m10 4h-2.25c-.414 0-.75.336-.75.75s.336.75.75.75h2.25z" fill="#1d83d4" />
</svg>


`;
